import { getNormalizedLanguageCode } from '@/static/languages';
import { useUserStore } from '@/stores/user';
import { isInCapacitorApp } from '@/utils/device';
import { secureStorageGet, deviceGetLanguageCode } from '@/utils/native/nativeBridge';

export const useMobileInit = () => {
  const userStore = useUserStore();
  const isMobile = isInCapacitorApp();

  const initializeNativeInfo = async () => {
    await Promise.all([setUserInfo(), setUserLanguage()]);
  };

  const setUserInfo = async () => {
    if (!isMobile) return;

    try {
      const authToken = await secureStorageGet({ key: 'authToken' });
      const userInfo = await userStore.fetchUserInfo();
      await userStore.setLoginInfo({ ...userInfo, token: authToken, loginType: 'SELF_SERVICE' });
    } catch (error) {
      console.error('모바일 사용자 정보 조회/설정이 실패했습니다:', error);
    }
  };

  const setUserLanguage = async () => {
    if (!isMobile) return;

    const languageCode = await getDeviceLanguage();
    userStore.setPageLanguage(languageCode);
  };

  const getDeviceLanguage = async () => {
    try {
      const languageCode = await deviceGetLanguageCode();
      return getNormalizedLanguageCode(languageCode);
    } catch (error) {
      console.error('Error fetching device language:', error);
    }
  };

  initializeNativeInfo();
};
